var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.33.5 8.66V0L8 4.33Z",
    fill: "#001C5B"
  })));
};
export default SvgPlay;